<template>
    <div class="previewpopup" v-if="dataVal.flag" @click.stop="handleRefund">
        <div class="preview" v-cloak>
            <img :src="dataVal.url" alt="" srcset="" v-if="dataVal.type == 'img'" @click.stop>
            <video :src="dataVal.url" controls v-if="dataVal.type == 'video'" @loadeddata="videoLoaded = true"
                @click.stop></video>
            <audio :src="dataVal.url" controls v-if="dataVal.type == 'audio'" @loadedmetadata="audioLoaded = true"
                @click.stop></audio>
        </div>
    </div>
</template>

<script>
export default {
    name: "Preview",
    props: ['dataVal'],
    data() {
        return {};
    },
    methods: {
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("previewCall", data);
        },
    },
    watch: {},
}
</script>

<style scoped lang="scss">
[v-cloak] {
    display: none;
}

.previewpopup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    .preview {
        width: 80%;
        height: 80%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            max-width: 100%;
            max-height: 100%;
        }

        video {
            max-width: 100%;
            max-height: 100%;
        }

        audio {
            max-width: 100%;
            max-height: 100%;
        }
    }
}
</style>